import { Operation } from "./Operation";
import { OperationContext } from "../OperationContext";

export class GetDocumentBody implements Operation<string> {
  async commit(context: OperationContext): Promise<string> {
    const body = context.document.body;
    body.load("text");
    await context.sync();
    return body.text;
  }

  merge(_: Operation<unknown>) {
    return undefined;
  }
}
